/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import "./List.scss";

function List({ long, children, ...restProps }: any) {
  return (
    <ul
      {...restProps}
      className={cn("list scope-005cf356", restProps.className, { "list--long": long })}
    >
      {children}
    </ul>
  );
}

export default List;
